import React from "react";
import { Menu, MenuItem, IconButton, Tooltip, Button } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";
interface ItemActionsProps {
    onImport?: () => void;
    onExport?: () => void;
    onIntegrate?: () => void;
    customActions?: CustomAction[];
}

interface CustomAction {
    label: string;
    onClick: () => void;
    color?: string;
}
const ItemListActions: React.FC<ItemActionsProps> = ({
    onImport,
    onExport,
    onIntegrate,
    customActions
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Actions">
                <Button variant="contained" onClick={handleClick}
                    endIcon={<MoreVertIcon />}
                    size="small"
                >
                    {t("common.actions")}
                </Button>

            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        width: anchorEl?.offsetWidth || undefined,
                    },
                }} >
                {onImport && (<MenuItem  onClick={() => { handleClose(); onImport(); }}>{t("common.import")}</MenuItem>)}
                {onExport && (<MenuItem onClick={() => { handleClose(); onExport(); }}>{t("common.export")}</MenuItem>)}
                {onIntegrate && (<MenuItem onClick={() => { handleClose(); onIntegrate(); }}>{t("common.integrate")}</MenuItem>)}
                {customActions?.map((action, idx) => (
                    <MenuItem
                        key={idx}
                        onClick={() => {
                            handleClose();
                            action.onClick();
                        }}
                        style={{ color: action.color ?? "inherit" }}
                    >
                        {action.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
export default ItemListActions;